import React from 'react'

const AuthLoadingContext = React.createContext({
    loading: {},
    setLoading: () => {}
})

export default AuthLoadingContext